import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import * as React from "react";
import { StartWishToGo } from "../wish-to-go-plugin/start-wish-to-go";
import GoogleIcon from "@fortawesome/fontawesome-free/svgs/brands/google.svg";
import { Link, navigate } from "gatsby";
import { siteMetadata } from "../../gatsby-config.js";
import { WishToGo } from "../wish-to-go-plugin/wish-to-go";
export var Subscribe = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Subscribe, _React$Component);

  function Subscribe(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      email: '',
      password: '',
      name: '',
      error: ''
    };
    return _this;
  }

  var _proto = Subscribe.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$state = this.state,
        email = _this$state.email,
        password = _this$state.password,
        name = _this$state.name,
        error = _this$state.error;
    return /*#__PURE__*/React.createElement("div", {
      className: "subscribe"
    }, /*#__PURE__*/React.createElement("div", {
      className: "subscribe-box"
    }, /*#__PURE__*/React.createElement("h2", null, "Create your Account"), /*#__PURE__*/React.createElement("div", {
      className: "email-sign-up"
    }, /*#__PURE__*/React.createElement("form", {
      onSubmit: function onSubmit(event) {
        return _this2.signWithEmail(email, password, name, event);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "field control"
    }, /*#__PURE__*/React.createElement("input", {
      className: "input",
      placeholder: "Your name",
      type: "text",
      autoComplete: "name",
      onChange: function onChange(event) {
        return _this2.setState({
          name: event.target.value
        });
      },
      value: name
    })), /*#__PURE__*/React.createElement("div", {
      className: "field control"
    }, /*#__PURE__*/React.createElement("input", {
      className: "input",
      placeholder: "Your email address",
      type: "email",
      autoComplete: "email",
      onChange: function onChange(event) {
        return _this2.setState({
          email: event.target.value
        });
      },
      value: email
    })), /*#__PURE__*/React.createElement("div", {
      className: "field control"
    }, /*#__PURE__*/React.createElement("input", {
      className: "input",
      placeholder: "Choose a password",
      type: "password",
      autoComplete: "current-password",
      onChange: function onChange(event) {
        return _this2.setState({
          password: event.target.value
        });
      },
      value: password
    })), /*#__PURE__*/React.createElement("div", {
      className: "field control is-grouped is-grouped-centered"
    }, /*#__PURE__*/React.createElement("button", {
      className: "button is-success is-fullwidth",
      type: "submit"
    }, "Subscribe with Email")))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
      className: "social-sign-up"
    }, /*#__PURE__*/React.createElement("button", {
      className: "button is-info is-fullwidth",
      onClick: function onClick() {
        return _this2.signWithProvider('google');
      }
    }, /*#__PURE__*/React.createElement("span", null, "Subscribe with Google"), /*#__PURE__*/React.createElement(GoogleIcon, null))), /*#__PURE__*/React.createElement("div", {
      className: "error " + (error ? '' : 'shrink-to-hide')
    }, error && /*#__PURE__*/React.createElement("p", null, error)), /*#__PURE__*/React.createElement(StartWishToGo, {
      noCounter: true
    })), /*#__PURE__*/React.createElement("small", null, "By subscribing to our service, you agree to our", /*#__PURE__*/React.createElement(Link, {
      to: "/legal/terms/"
    }, " Terms and Conditions"), " and", /*#__PURE__*/React.createElement(Link, {
      to: "/legal/privacy-policy/"
    }, " Privacy Policy"), "."));
  };

  _proto.getVerifiedURL = function getVerifiedURL(defaultParams) {
    var params = {
      plan: this.props.plan,
      email: (defaultParams === null || defaultParams === void 0 ? void 0 : defaultParams.email) || this.state.email,
      name: (defaultParams === null || defaultParams === void 0 ? void 0 : defaultParams.name) || this.state.name
    };
    var queryString = Object.keys(params).filter(function (key) {
      return params[key];
    }).map(function (key) {
      return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
    }).join('&');
    return "/verified?" + queryString;
  };

  _proto.signWithEmail = function signWithEmail(email, password, name, event) {
    var _this3 = this;

    event.preventDefault();
    WishToGo.auth().signUp({
      authProvider: 'email',
      email: email,
      password: password,
      name: name,
      verificationLink: siteMetadata.siteUrl + this.getVerifiedURL()
    }).then(function () {
      _this3.setState({
        error: ''
      });

      navigate('/plans/subscription/verification-email-sent/');
    }).catch(function (error) {
      if (error === 'auth/email-already-in-use') {
        WishToGo.auth().login({
          authProvider: 'email',
          email: email,
          password: password,
          name: name
        }).then(function (userCredential) {
          _this3.setState({
            error: ''
          });

          navigate(_this3.getVerifiedURL({
            name: userCredential.name,
            email: userCredential.email
          }));
        }).catch(function (error) {
          _this3.setState({
            error: 'Cannot sign up. Reason: ' + error
          });
        });
      }
    });
  };

  _proto.signWithProvider = function signWithProvider(provider) {
    var _this4 = this;

    WishToGo.auth().signUp({
      authProvider: provider
    }).then(function (userCredential) {
      _this4.setState({
        error: ''
      });

      navigate(_this4.getVerifiedURL({
        name: userCredential.name,
        email: userCredential.email
      }));
    }).catch(function (error) {
      _this4.setState({
        error: 'Cannot sign up. Reason: ' + error
      });
    });
  };

  return Subscribe;
}(React.Component);
Subscribe.initialized = false;